import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const EVENT_SLUG = "davangere-members-day-2026";

export function usePublicEvent(slug = EVENT_SLUG) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    axios.get(`${API}/events/${slug}/public`).then((r) => setData(r.data)).catch((e) => setError(e));
  }, [slug]);
  return { data, error };
}

export const publicApi = {
  uploadPhoto: (id, file) => {
    const fd = new FormData();
    fd.append("photo", file);
    return axios.post(`${API}/registrations/${id}/photo`, fd).then((r) => r.data);
  },
  sync: (id) => axios.post(`${API}/registrations/${id}/sync`).then((r) => r.data),
  checkSoftLaunch: (event_id, phone) => axios.post(`${API}/soft-launch/check`, { event_id, phone }).then((r) => r.data),
  resume: (event_id, phone) => axios.post(`${API}/registrations/resume`, { event_id, phone }).then((r) => r.data),
  createRegistration: (body) => axios.post(`${API}/registrations`, body).then((r) => r.data),
  updateBilling: (id, body) => axios.patch(`${API}/registrations/${id}/billing`, body).then((r) => r.data),
  createOrder: (id) => axios.post(`${API}/registrations/${id}/order`).then((r) => r.data),
  verify: (id, body) => axios.post(`${API}/registrations/${id}/verify`, body).then((r) => r.data),
  mockCapture: (id) => axios.post(`${API}/registrations/${id}/mock-capture`).then((r) => r.data),
  get: (id) => axios.get(`${API}/registrations/${id}`).then((r) => r.data),
  chapters: (slug = EVENT_SLUG) => axios.get(`${API}/events/${slug}/directory/chapters`).then((r) => r.data.items),
  regions: () => axios.get(`${API}/public/regions`).then((r) => r.data.items),
  directoryMembers: (region, chapter) =>
    axios.get(`${API}/public/directory/members`, { params: { region, chapter } }).then((r) => r.data.items),
  directoryCheckContact: (payload) =>
    axios.post(`${API}/public/directory/check-contact`, payload).then((r) => r.data),
  chapterMembers: (chapter, slug = EVENT_SLUG) =>
    axios.get(`${API}/events/${slug}/directory/members`, { params: { chapter } }).then((r) => r.data.items),
  sponsors: (slug = EVENT_SLUG) => axios.get(`${API}/events/${slug}/sponsors`).then((r) => r.data.items),
  requestPhoneCode: (event_id, phone) => axios.post(`${API}/verify/phone/request`, { event_id, phone }).then((r) => r.data),
  requestEmailCode: (event_id, email) => axios.post(`${API}/verify/email/request`, { event_id, email }).then((r) => r.data),
  confirmPhoneCode: (event_id, value, code) => axios.post(`${API}/verify/phone/confirm`, { event_id, value, code }).then((r) => r.data),
  confirmEmailCode: (event_id, value, code) => axios.post(`${API}/verify/email/confirm`, { event_id, value, code }).then((r) => r.data),
};

export function apiError(e) {
  const d = e?.response?.data;
  if (d?.errors?.length) return d.errors.map((x) => `${x.field}: ${x.message}`).join(" · ");
  if (typeof d?.detail === "string") return d.detail;
  if (d?.detail?.message) return d.detail.message;
  if (d?.detail?.errors) return d.detail.errors.map((x) => `${x.field}: ${x.message}`).join(" · ");
  return e?.message || "Request failed";
}

/** Structured guardrail payloads: {code, message, resume} on 429/403 */
export function guardrail(e) {
  const d = e?.response?.data?.detail;
  return d && typeof d === "object" && d.code ? d : null;
}

export function loadRazorpay() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(window.Razorpay);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(window.Razorpay);
    s.onerror = () => reject(new Error("Could not load Razorpay Checkout"));
    document.body.appendChild(s);
  });
}

export async function pollUntilPaid(id, { every = 1500, max = 20000 } = {}) {
  const start = Date.now();
  while (Date.now() - start < max) {
    const r = await publicApi.sync(id).catch(() => publicApi.get(id));
    if (r.status === "paid") return r;
    await new Promise((res) => setTimeout(res, every));
  }
  return publicApi.sync(id).catch(() => publicApi.get(id));
}

export const inr = (paise) => `₹${(paise / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
